import { zoomThreshold } from '../options';

/**
 * Check if tooltips should be displayed based on current zoom level
 *
 * @param {*} map
 */
export function checkTooltips(map) {
    map.eachLayer(function (l) {
        const toolTip = l.getTooltip();

        if (toolTip) {
            /* eslint-disable indent */
            map.getZoom() >= zoomThreshold
                ? l.unbindTooltip().bindTooltip(toolTip, {
                      permanent: true,
                      opacity: 0.9,
                  })
                : l.unbindTooltip().bindTooltip(toolTip, {
                      permanent: false,
                      opacity: 0,
                  });
            /* eslint-enable indent */
        }
    });
}
